import FootballStatsCategory from "../../../stats/football-stats-category";
import FootballState from "../../../state/football-state";
import StatsRule from "../../../../common/stats-rule";

export default class OutOfBoundsStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.OutOfBounds &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const stats = [];
        fragment.tackledBy.forEach((player) => {
            this.addStats(
                {
                    gameId: play.gameId,
                    playId: play.id,
                    period: gameContext.currentPeriod,
                    teamId: player.teamId,
                    playerId: player.id,
                    driveId: gameContext.currentDriveId,
                    fragmentId: fragment.id,
                    category: FootballStatsCategory.TACKLE,
                    values: {
                        completed: 1,
                        unassisted: fragment.tackledBy.length === 1 ? 1 : 0
                    }
                },
                stats
            );
        });

        return stats;
    }
}
